var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3976 7.14909L9.39763 19.1491C9.29216 19.2544 9.14919 19.3136 9.00013 19.3136C8.85107 19.3136 8.7081 19.2544 8.60263 19.1491L3.35263 13.8991C3.25327 13.7925 3.19918 13.6514 3.20175 13.5057C3.20432 13.36 3.26335 13.2209 3.36641 13.1179C3.46947 13.0148 3.60851 12.9558 3.75424 12.9532C3.89996 12.9506 4.041 13.0047 4.14763 13.1041L9.00013 17.9557L20.6026 6.35409C20.7093 6.25473 20.8503 6.20064 20.996 6.20321C21.1417 6.20578 21.2808 6.26482 21.3838 6.36788C21.4869 6.47094 21.5459 6.60998 21.5485 6.7557C21.5511 6.90143 21.497 7.04246 21.3976 7.14909Z",
    fill: "#404D6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.7ef6064db3b33e59df6336d8f705ca31.svg";
export { ForwardRef as ReactComponent };